import Marionette from 'backbone.marionette';
import billListItemviewTmpl from '../templates/bill_list_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billListItemviewTmpl,
  tagName: 'tr'
});